<template>
  <svg class="app-ctrl-svg-icon" version="1.1"
    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
    x="0px" y="0px" width="123px" height="39px" viewBox="-5.211 -4.228 123 39" enable-background="new -5.211 -4.228 123 39"
    xml:space="preserve">
  <defs>
  </defs>
  <g>
    <g>
      <path fill="#FFFFFF" d="M7.54,14.21c-2.027-0.82-2.693-1.306-2.693-2.247c0-0.911,0.76-1.609,2.186-1.609
        c1.331,0,2.566,0.485,3.326,0.88l0.887-3.158c-1.014-0.516-2.566-0.941-4.372-0.941c-3.929,0-6.463,2.308-6.463,5.344
        c0,1.852,1.204,3.644,4.499,4.919c1.933,0.789,2.534,1.336,2.534,2.368s-0.792,1.7-2.439,1.7c-1.458,0-3.2-0.607-4.119-1.123
        L0,23.592c1.172,0.668,3.042,1.123,4.974,1.123c4.403,0,6.938-2.125,6.938-5.344C11.912,17.034,10.518,15.394,7.54,14.21z
        M20.976,7.135c-5.164,0-8.079,4.19-8.079,9.048c0,5.253,3.104,8.532,8.554,8.532c2.186,0,4.245-0.364,5.703-0.972l-0.666-3.097
        c-1.204,0.395-2.566,0.698-4.309,0.698c-2.534,0-4.688-1.154-4.815-4.038h10.55c0.095-0.486,0.126-1.124,0.126-1.792
        C28.041,10.05,25.253,7.135,20.976,7.135z M17.364,14.18c0.127-1.67,1.077-3.917,3.327-3.917c2.313,0,3.042,2.156,3.01,3.917
        H17.364z M37.549,7.135c-4.784,0-8.363,3.219-8.363,8.896c0,5.495,3.421,8.714,8.173,8.714c3.928,0,8.237-2.489,8.237-8.927
        C45.596,10.688,42.492,7.135,37.549,7.135z M37.423,21.436c-2.281,0-3.485-2.489-3.485-5.495c0-2.581,0.918-5.496,3.517-5.496
        c2.408,0,3.39,2.824,3.39,5.466C40.844,18.917,39.64,21.436,37.423,21.436z M56.911,7.135c-2.249,0-3.896,0.911-4.91,2.399h-0.063
        V0h-4.688v19.553c0,1.731-0.063,3.644-0.127,4.858h3.991l0.222-2.338h0.096c1.108,1.913,2.788,2.672,4.752,2.672
        c3.644,0,7.223-2.976,7.223-9.108C63.405,10.597,60.807,7.135,56.911,7.135z M55.105,21.163c-1.869,0-3.168-1.578-3.168-3.491
        v-3.31c0-2.186,1.552-3.644,3.168-3.644c2.407,0,3.58,2.247,3.58,5.131C58.685,19.128,57.386,21.163,55.105,21.163z M67.307,0.486
        c-1.458,0-2.503,1.002-2.503,2.399c0,1.366,1.014,2.398,2.503,2.398c1.457,0,2.534-0.941,2.534-2.398
        C69.841,1.488,68.828,0.486,67.307,0.486z M64.994,24.412h4.689V7.5h-4.689V24.412z M72.314,24.412h4.688V0h-4.688V24.412z
        M79.634,24.412h4.688V7.5h-4.688V24.412z M81.947,0.486c-1.457,0-2.503,1.002-2.503,2.399c0,1.366,1.014,2.398,2.503,2.398
        c1.457,0,2.534-0.941,2.534-2.398C84.481,1.488,83.467,0.486,81.947,0.486z M92.339,3.097l-4.625,1.306V7.5h-2.313v3.31h2.313
        v7.804c0,1.882,0.095,6.103,5.164,6.103c1.362,0,2.503-0.151,3.136-0.395l-0.063-3.432c-0.475,0.092-0.854,0.152-1.521,0.152
        c-1.425,0-2.091-0.851-2.091-2.885v-7.348h3.896V7.5h-3.896V3.097z M108.087,7.5l-2.217,8.836
        c-0.254,1.063-0.539,2.247-0.729,3.157h-0.095c-0.222-0.941-0.538-2.125-0.823-3.157L101.625,7.5h-5.133l5.925,15.546
        c0.126,0.334,0.189,0.577,0.189,0.759c0,0.334-0.792,2.064-2.344,3.128c-0.824,0.546-1.711,1.032-2.472,1.244l1.173,3.796
        c1.045-0.183,2.851-0.79,4.562-2.368c1.996-1.913,3.484-4.889,5.449-10.354L112.966,7.5H108.087z"/>
    </g>
  </g>
  </svg>
</template>

<script>
export default {

}
</script>

<style>

</style>